<a
  (click)="openDialog()"
  class="icon-settings"
  matTooltipClass="info-tooltip"
  [matTooltip]="tooltipInfo.value"
>
</a>
